import React, { Component } from "react";
import axios from "axios";
import L from "leaflet";
import "../../leaflet/leaflet_colorpicker";
import "./css/leaflet.css";
import "../../App.css";
import CONFIG from "../../../src/config.json";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import Splitter from "../../components/splitter/splitter";
import D3LineGraph from "../../components/linegraph/linegraph";
import Loading from "../../components/loading/loading";

class Marker extends Component {
  state = {
    params: [],
    loading: true,
    failed: false,
  };

  toggleParameter = (name) => {
    var { params } = this.state;
    var i = params.findIndex((p) => p.name === name);
    params[i].active = !params[i].active;
    this.setState(params);
  };
  onMouseOver = () => {
    document.getElementById(this.props.data.color).style.display = "block";
  };
  onMouseOut = () => {
    document.getElementById(this.props.data.color).style.display = "none";
  };

  formatDate = (datetime) => {
    var a = new Date(datetime);
    var year = a.getFullYear();
    var month = a.getMonth() + 1;
    var date = a.getDate();
    return `${year}${month < 10 ? "0" + month : month}${
      date < 10 ? "0" + date : date
    }`;
  };

  downloadCSV = () => {
    try {
      var data = this.props.data.data;
      var csv = "data:text/csv;charset=utf-8";

      for (let param in data) {
        if (
          typeof data[param] === "object" &&
          "data" in data[param] &&
          data[param].data.length === data["time"].length
        ) {
          csv = csv + `,${param}`;
        } else if (param === "time") {
          csv = csv + `,${param}`;
        }
      }

      csv = csv + "\n";

      for (let i = 0; i < data["time"].length; i++) {
        for (let param in data) {
          if (
            typeof data[param] === "object" &&
            "data" in data[param] &&
            data[param].data.length === data["time"].length
          ) {
            csv = csv + `${data[param].data[i]},`;
          } else if (param === "time") {
            csv = csv + `${data[param][i]},`;
          }
        }
        csv = csv + "\n";
      }
      var name = `WeatherModel_${Math.round(data["lat"] * 1000) / 1000}_${
        Math.round(data["lng"] * 1000) / 1000
      }_${this.formatDate(data["time"][0])}_${this.formatDate(
        data["time"][data["time"].length - 1]
      )}.csv`;
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      console.log(e);
      console.error("Failed to convert data to .csv");
    }
  };

  componentDidUpdate = () => {
    var { loading, failed } = this.state;
    var { data } = this.props.data;
    if (failed === false && data === false) {
      this.setState({ loading: false, failed: true });
    } else if (Object.keys(data).length > 0 && loading) {
      var params = Object.keys(data.variables).map((k) => {
        return { name: k, active: false };
      });
      params[0].active = true;
      this.setState({ loading: false, params, failed: false });
    }
  };

  render() {
    var { data, deleteMarker } = this.props;
    var { params, loading, failed } = this.state;
    var active = params.filter((p) => p.active);
    return (
      <div
        className="markerBox"
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        id={data.color + "_box"}
      >
        <div className="markerHead" style={{ backgroundColor: data.color }}>
          Point: ({data.location.join(", ")}) {data.elevation}m
          <button onClick={this.downloadCSV}>Download Data</button>
          <span className="close" onClick={() => deleteMarker(data.color)}>
            &#215;
          </span>
        </div>
        {failed ? (
          <div className="markerMain failed">
            Failed to collect data for the given point and time series, please
            delete the point and try again.
          </div>
        ) : loading ? (
          <div className="markerMain">
            <Loading color={data.color} />
          </div>
        ) : (
          <div className="markerMain">
            <div className="dataParams">
              {params.map((p) => (
                <div
                  key={p.name}
                  className={p.active ? "button active" : "button"}
                  style={{ backgroundColor: data.color }}
                  title="Toggle parameter graph"
                  onClick={() => this.toggleParameter(p.name)}
                >
                  {p.name}
                </div>
              ))}
            </div>
            <div className="dataGraphs">
              {active.map((a) => (
                <div className="graph" key={a.name}>
                  <D3LineGraph
                    data={{
                      x: data.data.time,
                      y: data.data.variables[a.name].data.map((d) => {
                        let y = a.name.includes("T_") ? d - 273.15 : d;
                        return y < -3e38 ? 0 : y;
                      }),
                    }}
                    ylabel={a.name}
                    xlabel="Time"
                    yunits={
                      a.name.includes("T_")
                        ? "°C"
                        : data.data.variables[a.name].unit
                    }
                    lcolor={data.color}
                    lweight={2}
                    simple={true}
                    grid={true}
                    border={true}
                    xscale={"Time"}
                  />
                </div>
              ))}
              <div className="gridlocation">
                Grid Point Location: ({data.data.lat.toFixed(3)},{" "}
                {data.data.lng.toFixed(3)}) {data.data.elevation}m
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

class SideBar extends Component {
  render() {
    var { markers, deleteMarker, dateRange, updateDateRange } = this.props;
    var maxDate = new Date(new Date().getTime() + 5 * 24 * 60 * 60 * 1000);
    var minDate = new Date(2017, 0, 1);
    return (
      <div className="sidebar">
        <div className="dateselect">
          <DateRangePicker
            clearIcon={null}
            value={dateRange}
            onChange={updateDateRange}
            maxDate={maxDate}
            minDate={minDate}
          />
        </div>
        {markers.map((m) => (
          <Marker key={m.color} data={m} deleteMarker={deleteMarker} />
        ))}
      </div>
    );
  }
}

class Home extends Component {
  state = {
    markers: [],
    dateRange: [
      new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
      new Date(new Date().getTime() + 4 * 24 * 60 * 60 * 1000),
    ],
  };

  generateColor() {
    var ranges = [
      [150, 256],
      [0, 190],
      [0, 30],
    ];

    var g = function () {
      var range = ranges.splice(
        Math.floor(Math.random() * ranges.length),
        1
      )[0];
      return Math.floor(Math.random() * (range[1] - range[0])) + range[0];
    };
    return "rgb(" + g() + "," + g() + "," + g() + ")";
  }

  updateDateRange = (event) => {
    this.setState({ dateRange: event }, () => {
      this.updateData();
    });
  };

  updateData = () => {
    var { markers } = this.state;
    for (var marker of markers) {
      this.getData(marker.location[0], marker.location[1], marker.color);
    }
  };

  formatDate = (datetime) => {
    var a = new Date(datetime);
    var year = a.getFullYear();
    var month = a.getMonth() + 1;
    var date = a.getDate();
    return `${year}${month < 10 ? "0" + month : month}${
      date < 10 ? "0" + date : date
    }`;
  };

  getData = async (lat, lng, id) => {
    var { dateRange, markers } = this.state;
    var models = {
      cosmo: {
        forecast: "VNXZ32",
        reanalysis: "VNXQ34",
      },
      icon: {
        forecast: "icon-ch2-eps",
        reanalysis: "kenda-ch1",
      },
    };
    console.log(
      `Collecting data for [${lat},${lng}] from ${this.formatDate(
        dateRange[0]
      )} to ${this.formatDate(dateRange[1])}`
    );
    var data;
    var incoming;

    var model = "icon";
    if (dateRange[0] < new Date(2024, 7, 29)) {
      model = "cosmo";
    }

    var { data: metadata } = await axios.get(
      `${CONFIG.apiUrl}/meteoswiss/${model}/metadata`
    );
    var reanalysis_date = new Date(
      metadata.find((m) => m["model"] === models[model]["reanalysis"])[
        "end_date"
      ]
    );
    reanalysis_date.setUTCHours(0, 0, 0, 0);
    var forecast_date = new Date(reanalysis_date);
    forecast_date.setDate(reanalysis_date.getDate() + 1);

    var start_date = dateRange[0];
    start_date.setUTCHours(0, 0, 0, 0);
    var end_date = dateRange[1];
    end_date.setUTCHours(0, 0, 0, 0);

    if (end_date > reanalysis_date) {
      ({ data } = await axios.get(
        `${CONFIG.apiUrl}/meteoswiss/${model}/point/forecast/${
          models[model]["forecast"]
        }/${this.formatDate(forecast_date)}/${lat}/${lng}`
      ));
      data.time = data.time.map((t) => new Date(t));

      var end_plus_one = new Date(end_date);
      end_plus_one.setDate(end_date.getDate() + 1);

      if (start_date < forecast_date) {
        ({ data: incoming } = await axios.get(
          `${CONFIG.apiUrl}/meteoswiss/${model}/point/reanalysis/${
            models[model]["reanalysis"]
          }/${this.formatDate(start_date)}/${this.formatDate(
            reanalysis_date
          )}/${lat}/${lng}`
        ));
        incoming.time = incoming.time.map((t) => new Date(t));

        var r = new Date(Math.max(...incoming.time));
        r.setUTCHours(0, 0, 0, 0);

        let start = 0;
        let end = data.time.length;
        for (let i = 0; i < data.time.length; i++) {
          if (data.time[i] < r) start = Math.min(end, i + 1);
          if (data.time[i] < end_plus_one) end = Math.max(start, i);
        }
        data["time"] = incoming["time"].concat(data["time"].slice(start, end));
        for (let key of Object.keys(data.variables)) {
          data.variables[key].data = incoming.variables[key].data.concat(
            data.variables[key].data.slice(start, end)
          );
        }
      } else {
        let start = 0;
        let end = data.time.length;
        for (let i = 0; i < data.time.length; i++) {
          if (data.time[i] < start_date) start = Math.min(end, i + 1);
          if (data.time[i] < end_plus_one) end = Math.max(start, i);
        }
        data["time"] = data["time"].slice(start, end);
        for (let key of Object.keys(data.variables)) {
          data.variables[key].data = data.variables[key].data.slice(start, end);
        }
      }
    } else {
      ({ data } = await axios.get(
        `${CONFIG.apiUrl}/meteoswiss/${model}/point/reanalysis/${
          models[model]["reanalysis"]
        }/${this.formatDate(start_date)}/${this.formatDate(
          end_date
        )}/${lat}/${lng}`
      ));
      data.time = data.time.map((t) => new Date(t));
    }
    var i = markers.findIndex((m) => m.color === id);
    markers[i].data = data;
    var { gridMarker, polyline } = this.addGridMarker(
      [data.lat, data.lng],
      [lat, lng],
      id
    );
    if (gridMarker) {
      markers[i].gridMarker = gridMarker;
      markers[i].polyline = polyline;
      var a = this.colorpicker.getColor(L.latLng(lat, lng));
      var a1 = this.colorpicker.getColor(L.latLng(data.lat, data.lng));
      if (a1 === null) a1 = a;
      markers[i].elevation =
        Math.round(
          10 * (-10000 + (a[0] * 256 * 256 + a[1] * 256 + a[2]) * 0.1)
        ) / 10;
      markers[i].data.elevation =
        Math.round(
          10 * (-10000 + (a1[0] * 256 * 256 + a1[1] * 256 + a1[2]) * 0.1)
        ) / 10;
    }

    this.setState({ markers });
  };

  addGridMarker = (latlng, platlng, color) => {
    var gridMarker = false;
    var polyline = false;
    if (latlng[0]) {
      gridMarker = new L.marker(L.latLng(latlng[0], latlng[1]), {
        icon: L.divIcon({
          className: "map-marker",
          html:
            `<div style="position: absolute;">` +
            `<div class="dot" style="background-color:${color}"></div></div>`,
        }),
      })
        .bindTooltip(
          `Grid Point: ${latlng[0].toFixed(3)},${latlng[1].toFixed(3)}`
        )
        .addTo(this.markerGroup);
      polyline = L.polyline([platlng, latlng], {
        color: color,
        weight: 1,
        dashArray: "5, 5",
      }).addTo(this.map);
    }
    return { gridMarker, polyline };
  };

  addMarker = async (e) => {
    var { markers } = this.state;
    var color = this.generateColor();
    var location = [e.latlng.lat.toFixed(3), e.latlng.lng.toFixed(3)];
    var marker = new L.marker(e.latlng, {
      icon: L.divIcon({
        className: "map-marker",
        html:
          `<div style="padding:10px;transform:translate(2px, -21px);position: absolute;">` +
          `<div class="pin bounce" style="background-color:${color}">` +
          `</div><div class="pulse" id=${color}></div></div> `,
      }),
    }).addTo(this.markerGroup);

    marker.on("mouseover", () => {
      document.getElementById(color + "_box").style.boxShadow =
        "rgb(100 100 111 / 40%) 0px 7px 29px 0px";
    });
    marker.on("mouseout", () => {
      document.getElementById(color + "_box").style.boxShadow =
        "rgb(100 100 111 / 20%) 0px 7px 29px 0px";
    });

    var data = {};

    markers.unshift({ marker, color, data, location });
    this.setState({ markers }, () => {
      this.getData(e.latlng.lat, e.latlng.lng, color);
    });
  };

  deleteMarker = (id) => {
    var { markers } = this.state;
    var i = markers.findIndex((m) => m.color === id);
    this.map.removeLayer(markers[i].marker);
    try {
      this.map.removeLayer(markers[i].gridMarker);
      this.map.removeLayer(markers[i].polyline);
    } catch (e) {}
    markers.splice(i, 1);
    this.setState({ markers });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.verifyCode();
    }
  };

  input = (event) => {
    this.setState({ input: event.target.value });
  };

  addMap = () => {
    var southWest = L.latLng(45.4, 5.14);
    var northEast = L.latLng(48.23, 11.48);
    var bounds = L.latLngBounds(southWest, northEast);
    this.map = L.map("map", {
      preferCanvas: true,
      zoomControl: false,
      center: bounds.getCenter(),
      zoom: 9,
      minZoom: 8,
      maxBounds: bounds,
      maxBoundsViscosity: 1.0,
    });
    L.tileLayer(
      "https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg",
      {
        attribution:
          '<a title="Swiss Federal Office of Topography" href="https://www.swisstopo.admin.ch/">swisstopo</a>',
      }
    ).addTo(this.map);
    var topolink =
      "https://api.mapbox.com/v4/mapbox.terrain-rgb/{z}/{x}/{y}.pngraw?access_token=pk.eyJ1IjoiamFtZXNydW5uYWxscyIsImEiOiJjazk0ZG9zd2kwM3M5M2hvYmk3YW0wdW9yIn0.uIJUZoDgaC2LfdGtgMz0cQ";
    this.colorpicker = L.tileLayer
      .colorPicker(topolink, {
        opacity: 0,
      })
      .addTo(this.map);
    var map = this.map;
    var colorpicker = this.colorpicker;
    new L.Control.Zoom({ position: "topright" }).addTo(this.map);
    this.markerGroup = new L.LayerGroup().addTo(this.map);
    this.map.on("click", this.addMarker);
    this.map.on("mousemove", function (e) {
      var lat = Math.round(1000 * e.latlng.lat) / 1000;
      var lng = Math.round(1000 * e.latlng.lng) / 1000;
      var a = colorpicker.getColor(e.latlng);
      var alt = NaN;
      if (a !== null) {
        alt =
          Math.round(
            10 * (-10000 + (a[0] * 256 * 256 + a[1] * 256 + a[2]) * 0.1)
          ) / 10;
      }
      map.attributionControl.setPrefix(
        "(" + lat + "," + lng + ") " + alt + "m"
      );
    });
  };

  updateMap = () => {
    this.map.invalidateSize();
  };

  componentDidMount() {
    this.addMap();
  }

  render() {
    document.title = "Swiss Weather";
    var { markers, dateRange } = this.state;

    return (
      <Splitter
        first={<div id="map" />}
        second={
          <SideBar
            markers={markers}
            deleteMarker={this.deleteMarker}
            dateRange={dateRange}
            updateDateRange={this.updateDateRange}
          />
        }
        update={this.updateMap}
      />
    );
  }
}

export default Home;
